import { Button } from "@heroui/react";
import { DeviceType } from "@/types/common";

import { FetchedTag } from "@/services/api/fetchers/tags";

interface ConfirmDeleteTagContentProps {
  tag?: FetchedTag | null;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  deviceType: DeviceType;
}

export function ConfirmDeleteTagContent({ tag, onConfirm, onOpenChange, deviceType }: ConfirmDeleteTagContentProps) {
  return (
    <>
      <p>Are you sure you want to delete the tag "{tag?.name}"?</p>
      {deviceType === "mobile" && (
        <div className="flex gap-2 pt-2">
          <Button variant="flat" fullWidth onPress={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button color="primary" fullWidth onPress={onConfirm}>
            Delete
          </Button>
        </div>
      )}
    </>
  );
}
